import { supabaseClient } from "@/lib/supabase";
import { useQuery } from "@tanstack/react-query";

export interface DiaryLabelOption {
    label_id: string;
    label_name: string;
    label_description: string | null;
    label_url: string | null;
    label_variant: string | null;
}

export async function fetchDiaryLabels(): Promise<DiaryLabelOption[]> {
    const { data, error } = await supabaseClient
        .from("diary_labels")
        .select("label_id, label_name, label_description, label_url, label_variant")
        .order("label_name");

    if (error) throw error;
    return (data ?? []) as DiaryLabelOption[];
}

export const diaryLabelsQueryKey = ["diary-labels"];

export function useSelectDiaryLabels() {
    return useQuery({
        queryKey: diaryLabelsQueryKey,
        queryFn: fetchDiaryLabels,
    });
}
